import classNames from 'classnames';
import type { ButtonHTMLAttributes, FC } from 'react';
import './HeaderAttributeFilterButton.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export const HeaderAttributeFilterButton: FC<Props> = ({
  className,
  ...props
}) => (
  <button
    className={classNames('header-attribute-filter-button', className)}
    {...props}
  />
);
